<div class="dialog">
  <div class="dialog-head">
    <mat-icon *ngIf="data.notaType === 'ANOTACAO'">notes</mat-icon>
    <mat-icon *ngIf="data.notaType === 'LEMBRETE'">notifications</mat-icon>
    <h1 *ngIf="data.notaType === 'ANOTACAO'">ANOTAÇÕES</h1>
    <h1 *ngIf="data.notaType === 'LEMBRETE'">LEMBRETES</h1>
  </div>

  <div class="dialog-content custom-scroll">
    <app-notas-cliente
      [clienteCpf]="data.clienteCpf"
      [clienteSiglaMarca]="data.clienteSiglaMarca"
      [notaType]="data.notaType"
    ></app-notas-cliente>

    <app-disclaimer
      *ngIf="data.notaType === 'ANOTACAO' && !hasAnotacoes"
      matIconName="search_off"
      message="Esse cliente não possui anotações."
    ></app-disclaimer>

    <app-disclaimer
      *ngIf="data.notaType === 'LEMBRETE' && !hasLembretes"
      matIconName="search_off"
      message="Esse cliente não possui lembretes."
    ></app-disclaimer>
  </div>

  <div class="bottom-input">
    <input
      *ngIf="data.notaType === 'ANOTACAO'"
      [(ngModel)]="newNotaText"
      placeholder="Adicione uma anotação aqui"
    />
    <input
      *ngIf="data.notaType === 'LEMBRETE'"
      [(ngModel)]="newNotaText"
      placeholder="Adicione um lembrete aqui"
    />
    <mat-icon (click)="createNewNota()"> add_box </mat-icon>
  </div>
</div>
